import gql from 'graphql-tag'

export const GET_SERVICES_2_SSGROUP = gql`
  query Services2Ssgroup($filter: GetServices2SsgroupFilter!) {
    services2Ssgroup(filter: $filter) {
      isSuccessful
      errorCode
      errorName
      message
      status
      services2Ssgroup {
        data {
          serviceId
          ssgroupId
          type
          method
          intervalDistance
          reminderDistance
          intervalTime
          intervalPeriod
          reminderTime
          reminderPeriod
          intervalHourmeter
          reminderHourmeter
          intervalRefrigerator
          reminderRefrigerator
          ssgroup {
            name
          }
          service {
            name
            companyId
            serviceAction {
              action
            }
            serviceCategory {
              name
            }
          }
        }
        pagination {
          page
          show
          total
        }
      }
    }
  }
`

export const GET_SERVICE_2_SSGROUP_BY_ID = gql`
  query Service2Ssgroup($filter: GetService2SsgroupFilter!) {
    service2Ssgroup(filter: $filter) {
      isSuccessful
      errorCode
      errorName
      message
      status
      service2Ssgroup {
        serviceId
        ssgroupId
        type
        intervalDistance
        reminderDistance
        intervalTime
        intervalPeriod
        reminderTime
        reminderPeriod
        intervalHourmeter
        reminderHourmeter
        ssgroup {
          name
        }
        service {
          name
          serviceAction {
            action
          }
          serviceCategory {
            name
          }
        }
      }
    }
  }
`

export const VEHICLE_2_SSGROUP = gql`
  query Vehicle2Ssgroup($filter: GetVehicle2SsgroupFilter!) {
    vehicle2Ssgroup(filter: $filter) {
      isSuccessful
      errorCode
      errorName
      message
      status
      vehicles2Ssgroup {
        data {
          id
          imei
          licensePlate
          vehicleType {
            category
            manufacturer
            model
            type
          }
        }
        pagination {
          page
          show
          total
        }
      }
    }
  }
`

export const DUPLICATE_SSGROUP = gql`
  mutation DuplicateSsgroup($input: DuplicateSsgroupInput!) {
    duplicateSsgroup(input: $input) {
      isSuccessful
      errorCode
      errorName
      message
      status
      duplicateSsgroup {
        ssgroupId
        companyId
        name
        service2Ssgroup {
          serviceId
          ssgroupId
          type
          intervalDistance
          reminderDistance
          intervalTime
          intervalPeriod
          reminderTime
          reminderPeriod
          intervalHourmeter
          reminderHourmeter
          ssgroup {
            name
          }
          service {
            name
          }
        }
      }
    }
  }
`

export const CREATE_SERVICE_2_SSGROUP = gql`
  mutation CreateService2Ssgroup($input: CreateService2SsgroupInput!) {
    createService2Ssgroup(input: $input) {
      isSuccessful
      errorCode
      errorName
      message
      status
      createService2Ssgroup {
        serviceId
        ssgroupId
        type
        method
        intervalDistance
        reminderDistance
        intervalTime
        intervalPeriod
        reminderTime
        reminderPeriod
        intervalHourmeter
        reminderHourmeter
        intervalRefrigerator
        reminderRefrigerator
        ssgroup {
          name
          ssgroupId
        }
        service {
          name
          serviceAction {
            action
          }
          serviceCategory {
            name
          }
        }
      }
    }
  }
`

export const CREATE_VEHICLES_2_SSGROUP = gql`
  mutation CreateVehicle2Ssgroup($input: Vehicle2SsgroupInput!) {
    createVehicle2Ssgroup(input: $input) {
      isSuccessful
      errorCode
      errorName
      message
      status
      createVehicle2Ssgroup {
        vehicle {
          id
          imei
          licensePlate
          odometer
          hourmeter
          vehicleType {
            category
            manufacturer
            model
            type
          }
          status
        }
        ssgroup {
          name
          ssgroupId
        }
      }
    }
  }
`

export const UPDATE_SERVICE_2_SSGROUP = gql`
  mutation UpdateService2Ssgroup($input: UpdateService2SsgroupInput!) {
    updateService2Ssgroup(input: $input) {
      isSuccessful
      errorCode
      errorName
      message
      status
      updateService2Ssgroup {
        serviceId
        ssgroupId
        type
        method
        intervalDistance
        reminderDistance
        intervalTime
        intervalPeriod
        reminderTime
        reminderPeriod
        intervalHourmeter
        reminderHourmeter
        intervalRefrigerator
        reminderRefrigerator
        ssgroup {
          name
          ssgroupId
        }
        service {
          name
          serviceAction {
            action
          }
          serviceCategory {
            name
          }
        }
      }
    }
  }
`

export const DELETE_SERVICE_2_SSGROUP = gql`
  mutation DeleteService2Ssgroup($input: DeleteService2SsgroupInput!) {
    deleteService2Ssgroup(input: $input) {
      isSuccessful
      errorCode
      errorName
      message
      status
      deleteService2Ssgroup {
        serviceId
        ssgroupId
        type
        intervalDistance
        reminderDistance
        intervalTime
        intervalPeriod
        reminderTime
        reminderPeriod
        intervalHourmeter
        reminderHourmeter
        ssgroup {
          name
          ssgroupId
        }
        service {
          name
        }
      }
    }
  }
`

export const DELETE_VEHICLES_2_SSGROUP = gql`
  mutation DeleteVehicle2Ssgroup($input: Vehicle2SsgroupInput!) {
    deleteVehicle2Ssgroup(input: $input) {
      isSuccessful
      errorCode
      errorName
      message
      status
      deleteVehicle2Ssgroup {
        vehicle {
          id
          imei
          licensePlate
          odometer
          hourmeter
          vehicleType {
            category
            manufacturer
            model
            type
          }
          status
        }
        ssgroup {
          name
          ssgroupId
        }
      }
    }
  }
`

export const GET_SERVICE_TEMPLATES = gql`
  query ServiceTemplates($filter: ServiceTemplatesFilter) {
    serviceTemplates(filter: $filter) {
      isSuccessful
      errorCode
      errorName
      message
      status
      serviceTemplates {
        data {
          templateId
          companyId
          icon
          name
          totalServices
        }
        pagination {
          total
          page
          show
          startCursor
          endCursor
        }
      }
    }
  }
`

export const GET_SERVICE_TEMPLATES_BY_ID = gql`
  query ServiceTemplate($filter: ServiceTemplateFilter!) {
    serviceTemplate(filter: $filter) {
      isSuccessful
      errorCode
      errorName
      message
      status
      serviceTemplate {
        serviceTemplateSchedule {
          templateId
          intervalDistance
          intervalTime
          intervalPeriod
          intervalHourmeter
          type
          service {
            name
            serviceCategory {
              name
            }
            serviceAction {
              serviceActionId
              action
            }
          }
        }
        totalServices
      }
    }
  }
`

export const CREATE_SERVICE_2_SSGROUP_BY_TEMPLATE = gql`
  mutation CreateServices2Ssgroup($input: CreateServices2SsgroupInput!) {
    createServices2Ssgroup(input: $input) {
      isSuccessful
      errorCode
      errorName
      message
      status
      createServices2Ssgroup {
        data {
          serviceId
          ssgroupId
          service {
            name
          }
        }
      }
    }
  }
`
